import { useContext } from "react";
import { AppSettingsContext } from "../contexts";

/**
 * Provides the app settings context.
 * @returns The app settings context.
 */
export const useAppSettings = () => {
  const context = useContext(AppSettingsContext);
  if (!context) {
    throw new Error("useAppSettings must be used within a AppSettingsProvider");
  }
  return context;
};
